const FeedbackNegativeSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.948 3.163a.556.556 0 1 0-.785.785L7.214 8l-4.051 4.052a.556.556 0 0 0 .785.785L8 8.786l4.052 4.051a.556.556 0 0 0 .785-.785L8.786 8l4.051-4.052a.556.556 0 0 0-.785-.785L8 7.214 3.948 3.163Z"
      clipRule="evenodd"
    />
  </svg>
)
export { FeedbackNegativeSvg }
